// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconHeartFilled = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 5.337A5.5 5.5 0 002 8.5c0 3.672 2.38 6.796 4.554 8.905A27 27 0 009.59 19.93c.364.26 1.638 1.07 1.638 1.07h1.561c.56-.353 1.107-.734 1.64-1.134a30 30 0 003.025-2.604C19.61 15.125 22 11.999 22 8.5a5.5 5.5 0 00-10-3.163" />
  );
export default SvgIconHeartFilled;
